/* GLITTER GURL theme JS ✦ cart drawer + shade swap + upsell + PDP logic */
(function () {
  'use strict';
  var GG = window.GG || { money: function (c) { return '$' + c / 100; } };
  var GURL_MATH_HANDLES = ['jelly-glow-eyeshadow', 'glitter-jelly-lip-gloss', 'lip-stain-marker'];
  var CORE_HANDLES = ['jelly-glow-eyeshadow', 'glitter-jelly-lip-gloss', 'lip-stain-marker'];

  /* ── cart ─────────────────────────────────────── */
  var cartState = null;
  var productCache = {};
  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }
  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { cartState = c; renderCart(); return c; });
  }
  function addItemsRaw(items) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) { return r.json().then(function (e) { throw e; }); }
      return r;
    });
  }
  function addItems(items) { return addItemsRaw(items).then(function () { return fetchCart(); }); }
  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (c) { cartState = c; renderCart(); });
  }
  function swapVariant(item, newId) {
    addItemsRaw([{ id: newId, quantity: item.quantity }]).then(function () {
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      });
    }).then(function () { return fetchCart(); }).catch(function () { fetchCart(); });
  }

  function renderCart() {
    var c = cartState; if (!c) return;
    var badge = document.getElementById('gg-bag-count');
    if (badge) { badge.textContent = c.item_count; badge.hidden = c.item_count === 0; }
    if (window.__ggAnnounceRefresh) window.__ggAnnounceRefresh();
    var body = document.getElementById('gg-drawer-body');
    var upsellEl = document.getElementById('gg-upsell');
    var foot = document.getElementById('gg-drawer-foot');
    var title = document.getElementById('gg-drawer-count');
    if (title) title.textContent = '(' + c.item_count + ')';
    if (!body) return;
    if (c.item_count === 0) {
      body.innerHTML = '<div class="gg-drawer-empty">' +
        '<svg viewBox="0 0 24 24" style="width:20px;height:20px"><path d="M12 0 L14.4 9.6 L24 12 L14.4 14.4 L12 24 L9.6 14.4 L0 12 L9.6 9.6 Z" fill="#C59A4C"></path></svg>' +
        '<div style="font-size:14px;font-weight:600;letter-spacing:.06em">your bag is empty, gurl</div>' +
        '<a href="/collections/all" style="font-size:11px;letter-spacing:.2em;text-transform:uppercase;text-decoration:underline;text-underline-offset:3px">shop the sparkle →</a></div>';
      if (upsellEl) upsellEl.innerHTML = '';
      if (foot) foot.hidden = true;
      return;
    }
    var shop = (window.GG_SHOP && window.GG_SHOP.products) || {};
    var needed = {};
    c.items.forEach(function (it) { if (!shop[it.handle]) needed[it.handle] = 1; });
    Promise.all(Object.keys(needed).map(getProduct)).then(function (prods) {
      var byHandle = {};
      prods.forEach(function (p) { if (p) byHandle[p.handle] = p; });
      buildRows(c, byHandle, body, shop);
      buildFoot(c, foot);
    }).catch(function (e) {
      console.error('[GlitterGurl] drawer render failed', e);
      buildRows(c, {}, body, {});
      buildFoot(c, foot);
    });
  }

  function removeLines(keys) {
    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });
    return fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json(); }).then(function (c) { cartState = c; renderCart(); });
  }

  var GURL_SAVES = { 'jelly-glow-eyeshadow': [3, 15], 'glitter-jelly-lip-gloss': [6, 18], 'lip-stain-marker': [5, 17] };
  var TIER_QTY = [1, 2, 4];

  function buildRows(c, byHandle, body, shop) {
    body.innerHTML = '';
    var order = [], groups = {};
    c.items.forEach(function (it) {
      var key = shop[it.handle] ? 'g:' + it.handle : 'l:' + it.key;
      if (!groups[key]) { groups[key] = []; order.push(key); }
      groups[key].push(it);
    });
    order.forEach(function (key) {
      if (key.indexOf('g:') === 0) {
        buildGroupCard(key.slice(2), groups[key], body, shop);
      } else {
        buildPlainLine(groups[key][0], byHandle, body);
      }
    });
    var inCart = {};
    c.items.forEach(function (it) { inCart[it.handle] = 1; });
    var missing = CORE_HANDLES.filter(function (h) { return !inCart[h] && shop[h]; });
    if (missing.length) {
      var label = document.createElement('div');
      label.className = 'gg-discover-label';
      label.textContent = 'you might also love ✦';
      body.appendChild(label);
      missing.forEach(function (h) { buildDiscoverCard(h, body, shop); });
    }
  }

  function buildDiscoverCard(handle, body, shop) {
    var cfg = shop[handle];
    var card = document.createElement('div');
    card.className = 'gg-group gg-discover';
    var top = document.createElement('div');
    top.className = 'gg-group-top';
    top.style.cursor = 'pointer';
    top.innerHTML =
      (cfg.image ? '<img src="' + cfg.image + '" alt="">' : '') +
      '<div class="gg-line-info"><div class="gg-line-name">' + cfg.title + '</div>' +
      '<div class="gg-line-shade">' + GG.money(cfg.price) + ' · 5 shades</div></div>' +
      '<span class="gg-disc-toggle">▾</span>';
    card.appendChild(top);
    var list = null;
    top.addEventListener('click', function () {
      if (list) { card.removeChild(list); list = null; top.querySelector('.gg-disc-toggle').textContent = '▾'; return; }
      list = document.createElement('div');
      list.className = 'gg-shade-list';
      cfg.variants.forEach(function (v) {
        var row = document.createElement('div');
        row.className = 'gg-shade-row';
        var icon = document.createElement('span');
        icon.className = 's-icon';
        if (v.chip) icon.style.backgroundImage = "url('" + v.chip + "')";
        var name = document.createElement('span');
        name.className = 's-name';
        name.textContent = v.title;
        var plus = document.createElement('button');
        plus.type = 'button';
        plus.className = 'gg-sbtn plus';
        plus.textContent = '+';
        plus.setAttribute('aria-label', 'add ' + cfg.title + ' in ' + v.title);
        plus.addEventListener('click', function (e) {
          e.stopPropagation();
          plus.disabled = true;
          addItems([{ id: v.id, quantity: 1 }]);
        });
        row.appendChild(icon); row.appendChild(name); row.appendChild(plus);
        list.appendChild(row);
      });
      card.appendChild(list);
      top.querySelector('.gg-disc-toggle').textContent = '▴';
    });
    body.appendChild(card);
  }

  function buildGroupCard(handle, items, body, shop) {
    var cfg = shop[handle];
    var totalQty = 0, totalPrice = 0;
    var byVariant = {};
    items.forEach(function (it) {
      totalQty += it.quantity;
      totalPrice += it.final_line_price;
      byVariant[it.variant_id] = it;
    });
    var card = document.createElement('div');
    card.className = 'gg-group';
    var top = document.createElement('div');
    top.className = 'gg-group-top';
    top.innerHTML =
      (cfg.image ? '<img src="' + cfg.image + '" alt="">' : '') +
      '<div class="gg-line-info">' +
      '<div class="gg-line-name">' + cfg.title + '</div>' +
      '<div class="gg-line-shade">' + totalQty + ' in your bag</div>' +
      '<div style="font-size:12px;font-weight:600;margin-top:2px">' + GG.money(totalPrice) + '</div>' +
      '</div>' +
      '<button class="gg-line-x" data-gg-remove-all aria-label="remove all">✕</button>';
    top.querySelector('[data-gg-remove-all]').addEventListener('click', function () {
      removeLines(items.map(function (it) { return it.key; }));
    });
    card.appendChild(top);
    var list = document.createElement('div');
    list.className = 'gg-shade-list';
    cfg.variants.forEach(function (v) {
      var line = byVariant[v.id];
      var count = line ? line.quantity : 0;
      var row = document.createElement('div');
      row.className = 'gg-shade-row';
      var icon = document.createElement('span');
      icon.className = 's-icon';
      if (v.chip) icon.style.backgroundImage = "url('" + v.chip + "')";
      var name = document.createElement('span');
      name.className = 's-name' + (count > 0 ? ' has' : '');
      name.textContent = v.title;
      row.appendChild(icon);
      row.appendChild(name);
      if (count > 0) {
        var minus = document.createElement('button');
        minus.type = 'button';
        minus.className = 'gg-sbtn';
        minus.textContent = '−';
        minus.setAttribute('aria-label', 'remove one ' + v.title);
        minus.addEventListener('click', function () { changeLine(line.key, count - 1); });
        row.appendChild(minus);
        var badge = document.createElement('span');
        badge.className = 's-count';
        badge.textContent = 'x' + count;
        row.appendChild(badge);
      }
      var plus = document.createElement('button');
      plus.type = 'button';
      plus.className = 'gg-sbtn plus';
      plus.textContent = '+';
      plus.setAttribute('aria-label', 'add ' + v.title);
      plus.addEventListener('click', function () {
        plus.disabled = true;
        addItems([{ id: v.id, quantity: 1 }]);
      });
      row.appendChild(plus);
      list.appendChild(row);
    });
    card.appendChild(list);
    var saves = GURL_SAVES[handle];
    if (saves) {
      var nudge = document.createElement('div');
      nudge.className = 'gg-card-nudge';
      if (totalQty === 1) nudge.textContent = 'add 1 more shade ✦ gurl math takes $' + saves[0] + ' off';
      else if (totalQty === 2) nudge.textContent = 'duo discount applies at checkout ✦ buy 3 & the 4th is FREE';
      else if (totalQty === 3) nudge.textContent = 'gurl!! add 1 more shade ✦ it\'s FREE at checkout';
      else nudge.textContent = 'gurl math ✦ your free shade applies at checkout';
      card.appendChild(nudge);
    }
    body.appendChild(card);
  }

  function buildPlainLine(it, byHandle, body) {
    var row = document.createElement('div');
    row.className = 'gg-line-item';
    row.innerHTML =
      '<img src="' + (it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2') : '') + '" alt="">' +
      '<div class="gg-line-info">' +
      '<div class="gg-line-name">' + it.product_title.split(' ✦')[0] + '</div>' +
      '<div class="gg-line-shade" data-gg-shade-slot></div>' +
      '<div style="display:flex;align-items:center;gap:10px;margin-top:3px">' +
      '<div class="gg-qty"><button data-gg-dec aria-label="less">−</button><span>' + it.quantity + '</span><button data-gg-inc aria-label="more">+</button></div>' +
      '<div style="font-size:12px;font-weight:600">' + GG.money(it.final_line_price) + '</div>' +
      '</div></div>' +
      '<button class="gg-line-x" data-gg-remove aria-label="remove">✕</button>';
    var shadeSlot = row.querySelector('[data-gg-shade-slot]');
    var p = byHandle[it.handle];
    if (p && p.variants && p.variants.length > 1) {
      var sel = document.createElement('select');
      sel.className = 'gg-line-select';
      sel.setAttribute('aria-label', 'change shade');
      p.variants.forEach(function (v) {
        var o = document.createElement('option');
        o.value = v.id; o.textContent = v.title;
        if (v.id === it.variant_id) o.selected = true;
        sel.appendChild(o);
      });
      sel.addEventListener('change', function () { swapVariant(it, parseInt(sel.value, 10)); });
      shadeSlot.appendChild(sel);
    } else if (it.variant_title && it.variant_title !== 'Default Title') {
      shadeSlot.textContent = it.variant_title;
    }
    row.querySelector('[data-gg-dec]').addEventListener('click', function () { changeLine(it.key, it.quantity - 1); });
    row.querySelector('[data-gg-inc]').addEventListener('click', function () { changeLine(it.key, it.quantity + 1); });
    row.querySelector('[data-gg-remove]').addEventListener('click', function () { changeLine(it.key, 0); });
    body.appendChild(row);
  }

  function buildUpsell(c, upsellEl, shop) {
    if (!upsellEl) return;
    upsellEl.innerHTML = '';
    var inCart = {};
    c.items.forEach(function (it) { inCart[it.handle] = 1; });
    var missing = CORE_HANDLES.filter(function (h) { return !inCart[h] && shop[h]; }).slice(0, 2);
    if (!missing.length) return;
    var label = document.createElement('div');
    label.className = 'gg-upsell-label';
    label.textContent = 'complete the look ✦ tap a shade to add';
    upsellEl.appendChild(label);
    missing.forEach(function (h) {
      var p = shop[h];
      var row = document.createElement('div');
      row.className = 'gg-upsell-row';
      row.innerHTML =
        (p.image ? '<img src="' + p.image + '" alt="' + p.title + '">' : '') +
        '<div class="gg-upsell-info"><div>' + p.title + '</div><div class="p">' + GG.money(p.price) + '</div></div>';
      var chips = document.createElement('div');
      chips.className = 'gg-mini-chips';
      p.variants.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'gg-mini-chip';
        b.title = v.title + ' ✦ add';
        b.setAttribute('aria-label', 'add ' + p.title + ' in ' + v.title);
        if (v.chip) b.style.backgroundImage = "url('" + v.chip + "')";
        b.addEventListener('click', function () {
          b.style.opacity = '.4';
          addItems([{ id: v.id, quantity: 1 }]);
        });
        chips.appendChild(b);
      });
      row.appendChild(chips);
      upsellEl.appendChild(row);
    });
  }

  function buildFoot(c, foot) {
    if (!foot) return;
    foot.hidden = false;
    document.getElementById('gg-sum-subtotal').textContent = GG.money(c.original_total_price);
    var discountRow = document.getElementById('gg-discount-row');
    if (discountRow) {
      var d = c.total_discount || 0;
      discountRow.hidden = d <= 0;
      if (d > 0) document.getElementById('gg-sum-discount').textContent = '−' + GG.money(d);
    }
    document.getElementById('gg-sum-total').textContent = GG.money(c.total_price);
  }

  function openDrawer() {
    document.getElementById('gg-drawer').classList.add('open');
    document.getElementById('gg-overlay').classList.add('open');
  }
  function closeDrawer() {
    document.getElementById('gg-drawer').classList.remove('open');
    document.getElementById('gg-overlay').classList.remove('open');
  }
  window.addEventListener('gg-open-cart', openDrawer);

  /* ── header ───────────────────────────────────── */
  function initHeader() {
    var bagBtn = document.getElementById('gg-bag-btn');
    if (bagBtn) bagBtn.addEventListener('click', openDrawer);
    var closeBtn = document.getElementById('gg-drawer-close');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    var overlay = document.getElementById('gg-overlay');
    if (overlay) overlay.addEventListener('click', closeDrawer);
    var burger = document.getElementById('gg-burger');
    var mnav = document.getElementById('gg-nav-mobile');
    if (burger && mnav) burger.addEventListener('click', function () {
      mnav.classList.toggle('open');
      burger.textContent = mnav.classList.contains('open') ? '✕' : '☰';
    });
    updateMeters();
  }

  var FREE_SHIP_CENTS = 4000;
  function updateMeters() {
    var c = cartState;
    var total = (c && c.total_price) || 0;
    var text, pct;
    if (total >= FREE_SHIP_CENTS) { text = 'free delivery unlocked, gurl 💋'; pct = 100; }
    else { text = 'unlock free delivery ✦ ' + GG.money(FREE_SHIP_CENTS - total) + ' away'; pct = Math.min(100, total * 100 / FREE_SHIP_CENTS); }
    [['gg-announce-text', 'gg-meter-fill'], ['gg-cart-meter-text', 'gg-cart-meter-fill']].forEach(function (pair) {
      var t = document.getElementById(pair[0]);
      var f = document.getElementById(pair[1]);
      if (t) t.textContent = text;
      if (f) f.style.width = (pct < 5 ? 5 : pct) + '%';
    });
  }
  window.__ggAnnounceRefresh = updateMeters;

  /* ── accordions ───────────────────────────────── */
  function initAccordions(scope) {
    (scope || document).querySelectorAll('.gg-acc > button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var acc = btn.parentElement;
        var open = acc.classList.contains('open');
        acc.parentElement.querySelectorAll('.gg-acc').forEach(function (a) { a.classList.remove('open'); a.querySelector('button span:last-child').textContent = '+'; });
        if (!open) { acc.classList.add('open'); btn.querySelector('span:last-child').textContent = '—'; }
      });
    });
  }

  /* ── PDP ──────────────────────────────────────── */
  function initPdp() {
    var dataEl = document.getElementById('gg-product-data');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var state = { shade: 0, img: 0, tier: 0, slots: [], sel1: 0, sel2: 0 };
    if (data.type !== 'dual' && data.tierPrices && data.tierPrices.length >= 3) {
      state.tier = 1;
      state.slots = [null, null];
    }
    var mainEl = document.getElementById('gg-gallery-main');
    var thumbsEl = document.getElementById('gg-thumbs');
    var chipsEl = document.getElementById('gg-chips');
    var chips2El = document.getElementById('gg-chips-2');
    var shadeNameEl = document.getElementById('gg-shade-name');
    var shadeName2El = document.getElementById('gg-shade-name-2');
    var hintEl = document.getElementById('gg-pick-hint');
    var tiersEl = document.getElementById('gg-tiers');
    var slotsEl = document.getElementById('gg-slots');
    var ctas = Array.prototype.slice.call(document.querySelectorAll('[data-gg-cta]'));
    var priceEls = Array.prototype.slice.call(document.querySelectorAll('[data-gg-tier-price]'));

    function galleryFor(shadeName) {
      var hero = data.media.filter(function (m) { return m.alt === shadeName; });
      var rest = data.media.filter(function (m) { return m.alt !== shadeName && m.alt.indexOf(shadeName + ' ') === 0; });
      var shared = data.media.filter(function (m) { return m.alt.indexOf('✦') >= 0; });
      var out = hero.concat(rest, shared);
      return out.length ? out : data.media;
    }
    function bg(el, src) { el.style.backgroundImage = "url('" + src + "')"; }
    function defaultSlots(n) { var a = []; for (var i = 0; i < n; i++) a.push(i % data.variants.length); return a; }
    function shadeCarousel(shadeName) {
      var imgs = data.media.filter(function (m) { return m.alt === shadeName || m.alt.indexOf(shadeName + ' ') === 0; });
      if (!imgs.length) imgs = galleryFor(shadeName).slice(0, 5);
      var car = document.createElement('div');
      car.className = 'gg-shade-carousel';
      imgs.forEach(function (m) {
        var cell = document.createElement('div');
        cell.className = 'gg-carousel-cell';
        cell.style.backgroundImage = "url('" + m.src + "')";
        car.appendChild(cell);
      });
      return car;
    }

    function render() {
      var gallery, ctaLabel, ctaShort, ready = true, priceCents, shade = null;
      if (data.type === 'dual') {
        var v1 = data.options.values1[state.sel1];
        var v2 = data.options.values2[state.sel2];
        var g1 = (data.options.gal1 || [])[state.sel1] || {};
        var g2 = (data.options.gal2 || [])[state.sel2] || {};
        var mk = [{ src: g1.applied, alt: v1 + ' lips' }, { src: g1.hero, alt: v1 }];
        var gl = [{ src: g2.applied, alt: v2 + ' on lips' }, { src: g2.hero, alt: v2 }];
        var pairs = state.lastSel === 'sel2' ? [gl[0], mk[0], gl[1], mk[1]] : [mk[0], gl[0], mk[1], gl[1]];
        var shadeImgs = pairs.filter(function (p) { return p.src; });
        gallery = shadeImgs.concat(data.media);
        var key = data.options.values1[state.sel1] + '|' + data.options.values2[state.sel2];
        var v = data.variantMap[key];
        priceCents = data.priceCents;
        ctaLabel = 'Get the Combo ✦ ' + GG.money(priceCents);
        ctaShort = ctaLabel;
        state.resolved = v;
        if (shadeNameEl) shadeNameEl.textContent = data.options.values1[state.sel1];
        if (shadeName2El) shadeName2El.textContent = data.options.values2[state.sel2];
        renderDualChips();
      } else {
        shade = state.shade >= 0 ? data.variants[state.shade] : null;
        gallery = shade ? galleryFor(shade.shade) : data.media;
        var multi = state.tier > 0;
        ready = !multi || state.slots.every(function (s) { return s !== null; });
        var tierNames = ['just one', 'the duo', '4 shades (1 free)'];
        priceCents = data.tierPrices[state.tier];
        ctaLabel = multi ? 'Add ' + tierNames[state.tier] + ' ✦ ' + GG.money(priceCents) : 'Add to Bag — ' + GG.money(priceCents);
        ctaShort = multi ? 'Add ' + tierNames[state.tier] : 'Add to Bag';
        if (shadeNameEl) shadeNameEl.textContent = shade ? shade.shade : 'pick your shade ✦';
        renderTiers();
        renderChips();
        renderSlots();
      }
      state.img = Math.min(state.img, gallery.length - 1);
      var current = gallery[state.img] || gallery[0];
      if (mainEl && current) {
        bg(mainEl, current.src);
        var isHero = data.type === 'dual'
          ? (current.alt === data.options.values1[state.sel1] || current.alt === data.options.values2[state.sel2])
          : !!(shade && current.alt === shade.shade);
        mainEl.style.backgroundSize = isHero ? 'contain' : 'cover';
        mainEl.setAttribute('aria-label', current.alt);
      }
      if (thumbsEl) {
        thumbsEl.innerHTML = '';
        gallery.slice(0, 8).forEach(function (m, i) {
          var b = document.createElement('button');
          if (i === state.img) b.className = 'on';
          var d = document.createElement('div');
          d.className = 'gg-thumb-img';
          bg(d, m.src);
          b.appendChild(d);
          b.addEventListener('click', function () { state.img = i; render(); });
          thumbsEl.appendChild(b);
        });
      }
      ctas.forEach(function (btn) {
        var isSticky = btn.hasAttribute('data-gg-cta-short');
        if (isSticky && !ready) {
          btn.disabled = false;
          btn.textContent = 'pick your shades ✦';
        } else {
          btn.disabled = !ready;
          btn.textContent = isSticky ? ctaShort : ctaLabel;
        }
      });
      priceEls.forEach(function (el) { el.textContent = GG.money(priceCents); });
    }

    function renderTiers() {
      if (!tiersEl || !data.tierPrices || data.tierPrices.length < 3) return;
      var names = ['just one', '2 for ' + GG.money(data.tierPrices[1]), 'buy 3 get 1 free'];
      var tags = ['sale', 'most popular', 'best value'];
      var tagCls = ['raspberry', 'raspberry', 'gold'];
      tiersEl.innerHTML = '';
      names.forEach(function (name, t) {
        var save = data.tierSaves[t];
        var orig = (t === 0) ? (data.compareAtCents || 0) : data.tierPrices[0] * TIER_QTY[t];
        var priceHtml = (orig > data.tierPrices[t] ? '<span class="t-orig">' + GG.money(orig) + '</span>' : '') + GG.money(data.tierPrices[t]);
        var b = document.createElement('button');
        b.className = 'gg-tier' + (t === state.tier ? ' on' : '');
        b.innerHTML = (tags[t] ? '<span class="t-tag t-tag-' + tagCls[t] + '">' + tags[t] + '</span>' : '') +
          '<span class="t-name">' + name + '</span><span class="t-price">' + priceHtml + '</span>' +
          (save > 0 ? '<span class="t-save">save $' + save + '</span>' : '') +
          (t === 2 ? '<span class="t-free">+ free delivery ✦</span>' : '');
        b.addEventListener('click', function () {
          state.tier = t;
          state.slots = [];
          if (t > 0) {
            for (var s = 0; s < TIER_QTY[t]; s++) state.slots.push(null);
          }
          if (state.shade < 0) state.shade = 0;
          render();
        });
        tiersEl.appendChild(b);
      });
    }

    function renderChips() {
      if (!chipsEl) return;
      chipsEl.innerHTML = '';
      data.variants.forEach(function (v, i) {
        var b = document.createElement('button');
        b.className = 'gg-chip' + (i === state.shade ? ' on' : '');
        var visual = v.chip ? '<span class="c-img" style="background-image:url(\'' + v.chip + '\')"></span>' : '<span class="c-dot" style="background:' + (v.hex || '#F4CDCE') + '"></span>';
        b.innerHTML = visual + v.shade;
        b.addEventListener('click', function () { state.shade = i; state.img = 0; render(); });
        chipsEl.appendChild(b);
      });
    }

    var SLOT_ORD = ['first', 'second', 'third', 'fourth'];
    function buildShadeDropdown(slotIdx, pick, onPick) {
      var wrap = document.createElement('div');
      wrap.className = 'gg-dd-wrap';
      var box = document.createElement('div');
      box.className = 'gg-dd-box';
      var control = document.createElement('button');
      control.type = 'button';
      control.className = 'gg-dd-control' + (pick === null ? ' empty' : '');
      if (pick === null) {
        control.innerHTML = '<span class="dd-name">select your ' + SLOT_ORD[slotIdx] + ' shade</span><span class="dd-change">▾</span>';
      } else {
        var pv = data.variants[pick];
        control.innerHTML = '<span class="dd-sw"' + (pv.chip ? ' style="background-image:url(\'' + pv.chip + '\')"' : '') + '></span>' +
          '<span class="dd-name">' + pv.shade + '</span><span class="dd-change">change ▾</span>';
      }
      box.appendChild(control);
      var menu = document.createElement('div');
      menu.className = 'gg-dd-menu';
      menu.hidden = true;
      data.variants.forEach(function (v, i) {
        var opt = document.createElement('button');
        opt.type = 'button';
        opt.className = 'gg-dd-opt' + (pick === i ? ' on' : '');
        opt.innerHTML = '<span class="dd-sw"' + (v.chip ? ' style="background-image:url(\'' + v.chip + '\')"' : '') + '></span><span class="dd-name">' + v.shade + '</span>' + (pick === i ? '<span class="dd-tick">✓</span>' : '');
        opt.addEventListener('click', function () { onPick(i); });
        menu.appendChild(opt);
      });
      box.appendChild(menu);
      wrap.appendChild(box);
      if (pick !== null) {
        var car = document.createElement('div');
        car.className = 'gg-shade-carousel';
        galleryFor(data.variants[pick].shade).forEach(function (m) {
          var cell = document.createElement('div');
          cell.className = 'gg-carousel-cell';
          cell.style.backgroundImage = "url('" + m.src + "')";
          car.appendChild(cell);
        });
        wrap.appendChild(car);
      }
      control.addEventListener('click', function () {
        var willOpen = menu.hidden;
        slotsEl.querySelectorAll('.gg-dd-menu').forEach(function (m) { m.hidden = true; });
        slotsEl.querySelectorAll('.gg-dd-control').forEach(function (c) { c.classList.remove('open'); });
        if (willOpen) { menu.hidden = false; control.classList.add('open'); }
      });
      return wrap;
    }
    function renderSlots() {
      if (!slotsEl) return;
      slotsEl.innerHTML = '';
      if (state.tier === 0) { slotsEl.hidden = true; return; }
      slotsEl.hidden = false;
      state.slots.forEach(function (pick, slotIdx) {
        slotsEl.appendChild(buildShadeDropdown(slotIdx, pick, function (i) {
          state.slots[slotIdx] = i;
          state.shade = i;
          state.img = 0;
          render();
        }));
      });
      if (state.tier === 1 && state.slots.every(function (s) { return s !== null; })) {
        var nudge = document.createElement('button');
        nudge.type = 'button';
        nudge.className = 'gg-card-nudge gg-nudge-btn';
        nudge.textContent = 'gurl!! buy 3 & the 4th is FREE ✦ tap to upgrade →';
        nudge.addEventListener('click', function () {
          state.tier = 2;
          state.slots = [state.slots[0], state.slots[1], null, null];
          render();
        });
        slotsEl.appendChild(nudge);
      }
    }

    function renderDualChips() {
      [{ el: chipsEl, values: data.options.values1, sel: 'sel1', chips: data.options.chips1 },
       { el: chips2El, values: data.options.values2, sel: 'sel2', chips: data.options.chips2 }].forEach(function (group) {
        if (!group.el) return;
        group.el.innerHTML = '';
        group.values.forEach(function (val, i) {
          var b = document.createElement('button');
          b.className = 'gg-chip' + (state[group.sel] === i ? ' on' : '');
          var chip = group.chips && group.chips[i];
          var visual = chip ? '<span class="c-img" style="background-image:url(\'' + chip + '\')"></span>' : '<span class="c-dot" style="background:#F4CDCE"></span>';
          b.innerHTML = visual + val;
          b.addEventListener('click', function () { state[group.sel] = i; state.lastSel = group.sel; state.img = 0; render(); });
          group.el.appendChild(b);
        });
      });
    }

    function addToBag() {
      if (data.type !== 'dual' && state.tier > 0 && !state.slots.every(function (s) { return s !== null; })) {
        var slotsBox = document.getElementById('gg-slots');
        if (slotsBox) {
          slotsBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
          slotsBox.classList.add('pulse');
          setTimeout(function () { slotsBox.classList.remove('pulse'); }, 1700);
        }
        return;
      }
      var items;
      if (data.type === 'dual') {
        if (!state.resolved) return;
        items = [{ id: state.resolved, quantity: 1 }];
      } else if (state.tier === 0) {
        items = [{ id: data.variants[state.shade].id, quantity: 1 }];
      } else {
        var counts = {};
        state.slots.forEach(function (p) { var id = data.variants[p].id; counts[id] = (counts[id] || 0) + 1; });
        items = Object.keys(counts).map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
      }
      addItems(items).then(function () {
        if (state.tier > 0) {
          state.slots = [];
          for (var s = 0; s < TIER_QTY[state.tier]; s++) state.slots.push(null);
        }
        render();
        openDrawer();
      }).catch(function (e) { alert((e && e.description) || 'something went wrong, gurl. try again?'); });
    }
    ctas.forEach(function (btn) { btn.addEventListener('click', addToBag); });
    render();
  }

  function initSetOffer() {
    var link = document.getElementById('gg-checkout-btn');
    var modal = document.getElementById('gg-setoffer');
    if (!link || !modal) return;
    var offered = false;
    link.addEventListener('click', function (e) {
      var c = cartState;
      if (!c || offered) return;
      var perHandle = {};
      c.items.forEach(function (it) { if (CORE_HANDLES.indexOf(it.handle) >= 0) perHandle[it.handle] = (perHandle[it.handle] || 0) + it.quantity; });
      var hasThree = CORE_HANDLES.some(function (h) { return perHandle[h] === 3; });
      if (!hasThree) return;
      e.preventDefault();
      offered = true;
      modal.hidden = false;
      document.getElementById('gg-setoffer-reject').onclick = function () {
        modal.hidden = true;
        window.location.href = link.href;
      };
      document.getElementById('gg-setoffer-accept').onclick = function () {
        modal.hidden = true;
        var note = document.getElementById('gg-setoffer-note');
        if (note) note.hidden = false;
      };
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initAccordions();
    initPdp();
    initSetOffer();
    fetchCart();
  });
})();
